// @flow

import React, {Component} from 'react';
import {withCssModule} from '@pb/kit-util-with-css-module';
import StarSvg from './svg';

import styles from './star.module.styl';

import type {Theme, Size} from '../constants';

const classNames = withCssModule(styles);

/**
 * Star Props
 */
type StarProps = {|
    /**
     * Size of the Rating icon
     */
    size: Size,
    /**
     * Index of the Rating icon
     */
    index: number,
    /**
     * Value of Rating
     */
    grade: number,
    /**
     * Style of Rating
     */
    theme: Theme,
    /**
     * Rating is not clickable
     */
    readonly: boolean,
    /**
     * Index of the Rating icon on hover
     */
    hoverIndex: number,
    /**
     * Callback on click
     */
    onClick: (index: number) => void,
    /**
     * Callback on onMouseOver
     */
    onMouseOver: (index: number) => void,
|};


/**
 * The Star component
 *
 * @component
 * @name Star
 * @returns {HTMLSpanElement}
 */
export class Star extends Component<StarProps> {
    onClick = () => {
        if (!this.props.readonly) {
            this.props.onClick(this.props.index);
        }
    };

    onMouseOver = () => {
        if (!this.props.readonly) {
            this.props.onMouseOver(this.props.index);
        }
    };

    render() {
        const {index, hoverIndex, grade, size, readonly, theme} = this.props;
        const fillToIndex = hoverIndex || grade;
        const isFilled = index <= fillToIndex;
        const isHalf = !isFilled && index === Math.ceil(fillToIndex);

        const classes = classNames('star', `star_size${size}`, {
            star_readonly: readonly
        });

        return (
            <span className={classes} onClick={this.onClick} onMouseOver={this.onMouseOver}>
                <StarSvg {...{isFilled, isHalf, theme, size}} />
            </span>
        );
    }
}

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../constants");
